import { ListFilterScreenProps } from "./useFilters";
import { getMultilingualString } from "shared/utils";
import { useTranslation } from "react-i18next";
import { EnumTagGroupKey, EnumTagGroupType } from "gql/generated";
import { Center } from "styled-system/jsx";
import { Spinner } from "@ttc3k/trekker";
import { Checklist, EmptyState } from "shared/components";
import _ from "lodash";
import { useBuildListContext } from "../BuildListContext";

export const BackOfficeTagsFilter = ({
  filters,
  onUpdateFilters,
}: ListFilterScreenProps) => {
  const { t } = useTranslation();

  const { tags, tagsError, tagsLoading } = useBuildListContext();

  const filteredTags = tags.filter(
    (tag) =>
      tag.tagGroup?.key === EnumTagGroupKey.BackOffice &&
      tag.tagGroup.type === EnumTagGroupType.OrganizationSpecific,
  );

  if (tagsLoading) {
    return (
      <Center h={"full"}>
        <Spinner w={"40px"} h={"40px"} />
      </Center>
    );
  }

  if (tagsError) {
    throw new Error("Error loading tags");
  }

  if (!filteredTags || filteredTags.length < 1) {
    return <EmptyState text={t("core:FILTER.BACK_OFFICE_TAGS.EMPTY")} />;
  }

  const formattedTagData = _.sortBy(
    filteredTags.map((tag) => ({
      label: getMultilingualString(tag.name),
      value: tag._id,
    })),
    (group) => group.label.toLowerCase(),
  );

  const selectedTags = filters.tags.organizationSpecific;

  const handleTagSelect = (tagIds: string[]) => {
    onUpdateFilters({
      tags: {
        ...filters.tags,
        organizationSpecific: tagIds,
      },
    });
  };

  return (
    <Checklist
      data={formattedTagData}
      value={selectedTags}
      onValueChange={handleTagSelect}
    />
  );
};
